import React from "react";
import { Section } from "@dc/react-components";
import LionKingImage from "../../../assets/images/lyon_king_theatre.jpg";

import "./BannerTabs.scss";
import Tabs from "./Tabs.js";

const tabs = [
  {
    href: "#ID1",
    className: "tabs__tab tabs__tab--active",
    text: "Rewards"
  },
  {
    href: "#ID2",
    className: "tabs__tab",
    text: "Network"
  },
  {
    href: "#ID3",
    className: "tabs__tab",
    text: "More 5G"
  },
  {
    href: "#ID4",
    className: "tabs__tab",
    text: "Roaming"
  }
];

const tabcontent = {
  imageUrl: LionKingImage,
  title: "VeryMe Rewards",
  text: "Our exclusive pre-sale for The Lion King DE Tour in Berlin and Munich. Keep checking VeryMe Rewards to be first to be first to know about the next exclusive reward from Te Lion King tour."
};

function BannerTabs() {
  return (
    <>
      <Section color="wild-sand">
        <div className="spring">
          <h3 className="heading heading--4 section__title">Why choose Vodafone?</h3>
        </div>
      </Section>
      <Section className="section section--white flush--all banner-tabs--section">
        <div className="spring banner-tabs">
          <div className="grid grid--gutter banner-tabs__wrapper">
            <div className="grid__item grid__item--1/2 grid__item--md-1/1 grid__item--sm-1/1">
              <div className="">
                <div className="tabs">
                  <Tabs tabs={tabs} tabcontent={tabcontent} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Section>
    </>
  );
}

export default BannerTabs;
